import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { set_posts } from '../../actions';
import { client } from './../../contentful/contentful';
import toSlugCase from 'to-slug-case';
import {format} from 'date-fns';

const Blog = () => {

  const dispatch = useDispatch();
  const [posts, setPosts] = useState([]);
  const [paginationNumber,setPaginationNumber] = useState(0);
  const [paginationItems,setPaginationItems] = useState([]);
  const [pageNumberActive,setPageNumberActive] = useState(1);
  const [skip,setSkip] = useState(0);
  const [loading,setLoading] = useState(true);
  const set_posts_store = (posts) => dispatch( set_posts(posts) );

  const calculatePaginationNumber = (numberOfRecords) =>{
    let paginationNumber = (numberOfRecords / 8);
    if( paginationNumber % 1 !== 0 ){
      paginationNumber += 1;
      setPaginationNumber(Number(Math.trunc(paginationNumber)));
    }else{
      setPaginationNumber(paginationNumber);
    }
  }

  useEffect( () =>{ 
    try {
      client.getEntries({
        limit: 8,
        skip,
        'content_type': 'blogPost'
        }).then( response =>{
        setPosts(response.items);
        set_posts_store(response.items);
        calculatePaginationNumber(response.total);
        setLoading(false);
      });
      renderPageNumbersItems();
    } catch (error) {
      console.log('error obteniendo posts ' + error);
    }
  },[paginationNumber,skip]);

  const renderPageNumbersItems = (pageNumber = pageNumberActive) =>{
    let pagNumberAux = [];
    for( let i = 1 ; i <= paginationNumber ; i ++){
      pagNumberAux.push(
        <li className={"page-item" + (pageNumber === i ? ' active' : '' )}>
          <a className="page-link" onClick={ () => skipPage(i)} >
            {i}
          </a>
        </li>
      );
    }
    setPaginationItems(pagNumberAux);
  }

  const skipPage = (paginationItem) =>{
    if(paginationItem <= 0 || paginationItem > paginationNumber) return;
    setPageNumberActive(paginationItem);
    renderPageNumbersItems(paginationItem);
    paginationItem -= 1;
    setSkip( 8 * paginationItem);
  }

  
  const renderTags = (tags) =>{

    return (
      <>
        {
          (tags !== undefined) ? 
            tags.map( (tag,index) =>(
              <span key={index} className="category position-absolute badge badge-pill badge-primary">
                {tag}
              </span>
            )) 
            : null
        }
      </>
    )
  }
  
  return ( 
    <Fragment>
      {
        loading ? 
        <div className="container">
          <div className="row">
            <div className="col d-flex justify-content-center my-5">
              <div class="spinner-border text-danger" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        </div>
        :
        <section className="our-blog-section ptb-100 gray-light-bg">
        <div className="container">
            {
              posts.length !== 0 ? 
              <>
                <div className="row">
                  <div className="col-md-8">
                    <div className="section-heading mb-5">
                      <h2>Our Latest News</h2>
                      <p>
                        Enthusiastically drive revolutionary opportunities before
                        emerging leadership. Distinctively transform tactical
                        methods of empowerment via resource sucking core.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="row">
                  {
                    posts.map( (post,index) =>(
                      <div className="col-md-4" key={index}>
                        <div className="single-blog-card card border-0 shadow-sm">
                          {
                            renderTags(post.fields.tags)
                          }
                          <Link title={`${post.fields.title}`} to={`blog/${toSlugCase(format(new Date(post.fields.date),'yy MM'))}/${toSlugCase(post.fields.title)}/${post.sys.id}`}>
                            <img
                                src={post.fields.thumbnail.fields.file.url}
                                className="card-img-top position-relative"
                                alt="blog"
                            />
                          </Link>
                          <div className="card-body">
                            <div className="post-meta mb-2">
                              <ul className="list-inline meta-list">
                                <li className="list-inline-item">{format(new Date(post.fields.date),'MMM dd yyyy')}</li>
                              </ul>
                            </div>
                            <h3 className="h5 card-title">
                              <Link to={`blog/${toSlugCase(format( new Date(post.fields.date),'yy MM'))}/${toSlugCase(post.fields.title)}/${post.sys.id}`}>{post.fields.title}</Link>
                            </h3>
                            <p className="card-text">
                              {post.fields.shortDescription}
                            </p>
                            <Link className="detail-link" to={`blog/${toSlugCase(format( new Date(post.fields.date),'yy MM'))}/${toSlugCase(post.fields.title)}/${post.sys.id}`} >
                              Leer más <span className="ti-arrow-right"></span>
                            </Link>
                          </div>
                        </div>
                      </div>
                    ))
                  }
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <nav className="custom-pagination-nav mt-4">
                      <ul className="pagination justify-content-center">
                        <li className="page-item">
                          <a className="page-link" onClick={ () => skipPage(pageNumberActive - 1 )} >
                            <span className="ti-angle-left"></span>
                          </a>
                        </li>
                        {paginationItems}
                        <li className="page-item">
                          <a className="page-link" onClick={ () => skipPage(pageNumberActive + 1 )}>
                            <span className="ti-angle-right"></span>
                          </a>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </>
              : 
              <div className="container">
                <div className="row">
                  <div className="col d-flex justify-content-center my-5">
                    <p>En el momento no hay blogs</p>
                  </div>
                </div>
              </div>
            }
        </div>
      </section>
      }
      </Fragment>
   );
}
 
export default Blog;
